import { render, staticRenderFns } from "./SlideContent.vue?vue&type=template&id=39b8dc32&scoped=true"
import script from "./SlideContent.vue?vue&type=script&lang=js"
export * from "./SlideContent.vue?vue&type=script&lang=js"
import style0 from "./SlideContent.vue?vue&type=style&index=0&id=39b8dc32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b8dc32",
  null
  
)

export default component.exports